import WebglManager from "@/glxp/webglManager"
import TensorManager from "@/tensor/tensorManager"
import WebsocketManager from '@/js/websocketManager.js'
import DebugController from '@/glxp/debug/debugController'
import GameManager from '@/js/gameManager'
import Intro from '../Intro'
import ProgressCircle from '../progressCircle'
import Countdown from '../Countdown'
import EndScore from '../EndScore'
import Score from "../Score"
import easing from '../../glxp/utils/easing'
import Logo from '@/assets/images/logoHands.png'
import Preload from '@/assets/images/preloader.png'
import Load from '@/assets/images/soundRound.png'
import Dash from '@/assets/images/soundDash.png'
import Timer from '@/glxp/utils/timer'
import RAF from '@/js/utils/raf'
import { TweenMax, Power1 } from "gsap/gsap-core"

import Bowser from 'bowser'
import AudioManager from '@/js/audioManager'

import { getCookie } from '@/js/utils/helpers'


export default {
  name: "home",
  data: ()=>{
    return {
        tutoStep: 0,
        oponentName: "",
        nickname: "",
        message: "",
        firstMessage: '',
        tutoMessage: '',
        greetings: "",
        roundSubtitle: '',
        currentSign: "none",
        currentSignOpponent: "none",
        activeSignOpp: '',
        activeSignMe: '',
        currentRound: 0,
        showTuto: false,
        canSkipIntro: false,
        showOponentName: false,
        posHandOpp: '',
        posHandMe: '',
        showSigns: false,
        result: '',
        gameEnd: false,
        isMobile: false,
        Logo: Logo,
        Preload: Preload,
        isStarted: false,
        beforePlay : false,
        sound: true,
        sound: getCookie('muted') !== '1',
        soundCircle: Load,
        dash: Dash,
        soundProgress: 1,
        buttonMode: false,
        askButton: false,
        hideButtonMode: true,
        isSound: false,
        isLoading: false,
        hideButton: false,
        scores: {
          me: 0,
          opponent: 0,
        },
        displayedScore: {
          me: [],
          opponent: []
        }
    }
  },
  components: {
    'Intro': Intro,
    'Progrress': ProgressCircle,
    'Countdown': Countdown,
    'EndScore': EndScore,
    'Score': Score,
  },


  mounted() {
    // TensorManager.on("loaded", () => { this.initWebgl() })
    this.isMobile = Bowser.getParser(window.navigator.userAgent).parsedResult.platform.type === 'mobile'
    this.audio = new AudioManager()
    document.addEventListener('focus', this.setSound.bind(this))

    if(!this.isMobile) {
      this.$nextTick(() => {
        this.game = new GameManager(this)
        this.glxp = WebglManager.getScene("main")
        TensorManager.setDom(this.$refs["playback"])
        this.preloadWebgl()
      })
    } else {
      window.addEventListener('resize', () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      })
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      setTimeout(() => {
        document.querySelector(".mobile-screen").classList.add('visible')
      }, 200)
      setTimeout(() => {
        document.querySelector(".mobile-screen").classList.add('show')
      
      }, 1000)
      document.querySelector(".preloader-section").style.display = 'none'
      document.querySelector(".webgl-main-container").style.display = 'none'
    }
    // this.setSoundCanvas()
    // RAF.suscribe("spundCircle", this.soundCircleUpdate.bind(this))
  },

  beforeDestroy() {
    WebglManager.desactivate("main")
  },

  methods: {

    preloadWebgl(){
      
      this.glxp.preload().then(()=>{
          WebglManager.activate("main")
          setTimeout(() => {
            document.querySelector(".preloader-section").classList.add("hidden")
            document.querySelector(".webgl-main-container").classList.add("intro")
          }, 100);

          this.$refs["intro"].show()

          // Dev shortcut
          if (DebugController.queryDebug()) {
            setTimeout(() => {
              this.initWebgl()
            }, 200);
          } else {
            setTimeout(() => {
              this.initWebgl()
              
            }, 6000);
          }

        })
      },

      initWebgl(){
        setTimeout(() => {
          this.readingTime = true
          if(this.webGlLoaded) {
           
            if (DebugController.queryDebug()) {
              document.addEventListener('keydown', (evt) => {
                if (evt.key == "s") {
                  this.startWebgl()
                  // this.glxp.startIntro()
                  this.$refs["intro"].startCamera()

                }
              })
              
            } else {
              // this.$refs["intro"].showStep2()
              this.$refs.intro.isLoaded = true
              if(!this.isStep2 && this.$refs.intro.textEnded){
                this.$refs["intro"].showStep2()
              }
              // setTimeout(() => {
              //   document.querySelector(".webgl-main-container").classList.remove("intro")
              //   this.glxp.startIntro()
              // }, 500);
            }
            setTimeout(() => {
              this.initSocket()
              this.game.initEvents()
            }, 6000);
          }
        }, 0)
        WebglManager.loadScene("main").then(() => {
          this.webGlLoaded = true
          if(this.readingTime){
            setTimeout(() => {
            
               // Dev shortcut
               if (DebugController.queryDebug()) {
                document.addEventListener('keydown', (evt) => {
                  if (evt.key == "s") {
                    this.startWebgl()
                    // this.glxp.startIntro()
                    this.$refs["intro"].startCamera()
                    setTimeout(() => {
                      this.glxp.animationManager.goToStage(0)
                    }, 750)
                  }
                  if (evt.key == "u") {
                    this.isStarted = false
                    this.glxp.unStart()
                    // this.glxp.startIntro()
                    this.$refs["intro"].startCamera()
                  }
                })
                
              }  else {
                // this.$refs["intro"].showStep2()
                this.$refs.intro.isLoaded = true
                if(!this.isStep2 && this.$refs.intro.textEnded){
                  this.$refs["intro"].showStep2()
                }
                // document.querySelector(".webgl-main-container").classList.remove("intro")
                // this.glxp.startIntro()
              }
              setTimeout(() => {
                this.initSocket()
                this.game.initEvents()
              }, 6000);
            }, 500);
          }
         
      })
    },

    showFinalScore(leave = false){
      this.$refs["endscore"].opponent = this.oponentName
      this.$refs["endscore"].leave = leave
      if (this.scores.me > this.scores.opponent) {
        this.$refs["endscore"].win = true
        this.audio.play('win')
      } else {
        this.$refs["endscore"].win = false
        this.audio.play('loose')
      }
      this.$refs["endscore"].visible = true
    },

    getPos(){
      this.$refs.progress.updateBind()
    },

    startWebgl(){
      // console.log('start', this.isStarted)
      if (this.isStarted) return
      this.$refs["intro"].$el.style.display = "none"

      this.glxp.start()
      

      this.audio.play('leaves')
    
      TweenMax.delayedCall(4, () => {
        this.$refs["nav"].classList.add("active")
      })
      TweenMax.delayedCall(5, () => {
        this.game.startTuto(this.glxp)
      })
      this.isStarted = true
    },

    endTuto(){
      this.game.endTuto()
    },

    restartGame(){
      WebsocketManager.close()
      this.currenRound = 0
      this.game.restartGame()
      this.$refs["endscore"].visible = false
      this.$refs["endscore"].opponent = ""
      this.scores.me = 0
      this.scores.opponent = 0
    },

    initSocket(){
      WebsocketManager.init()
    },

    promptMessage(message, dest = 'message'){

      if(this[dest] !== '' && this.spanify(message) !== this[dest]) {
        this.$refs[dest].classList.add("leave")
        setTimeout(() => {
          this.$refs[dest].classList.remove("leave")
          this.
          $refs[dest].classList.remove("active")
          setTimeout(() => {
            this[dest] = this.spanify(message, 0.05)
            setTimeout(() => {
              this.$refs[dest].classList.add("active")
            }, 50)
          }, 100)
        }, 200)
      } else {
        this[dest] = this.spanify(message, 0.05)

        setTimeout(() => {
          this.$refs[dest].classList.add("active")
        }, 50)
      }
    },

    setMessage(dest) {
        this.$refs[dest].classList.remove("active")

          this.$nextTick(() => {
            let split = new SplitText(this.$refs[dest], { type: "chars" }), chars = split.chars;
            TweenMax.fromTo(chars,
              {
                autoAlpha: 0,
                y: 40
              },
              {
                duration: .7,
                autoAlpha: 1,
                y: 0,
                ease: "power3.out",
                stagger: { each: 0.02, ease: "sin.out" },
              },
            )
            TweenMax.to(chars,
              {
                delay: 2 + chars.length * 0.05,
                duration: .7,
                autoAlpha: 0,
                y: -40,
                ease: "power3.in",
                stagger: { each: 0.02, ease: "sin.out" },
                onComplete: () => {
                  this.$refs.message.classList.remove("active")
                  this[dest] = ""
                }
              },
            )

          })
        this.$refs[dest].classList.add("active")
    },

    spanify(text, delay, mainDelay = 0) {
      let t = text.split(" ")
      let out = ""
      let tmp = 0
      t.forEach(l => {
        out += ' <span class="word"> '
        let w = l.split("")
        w.forEach(c => {
          if (delay) {
            out += '<span style=" transition-delay:' + (tmp * delay + mainDelay) + 's" class="letter">'
            out += c
            out += '</span>'
            tmp++
          } else {
            out += '<span class="letter">'
            out += c
            out += '</span>'
            tmp++
          }
        })
        out += '</span>'
        if (w.includes("\n")) {
          out += '<br/>'
        }
      })
      return out
    },
    titleClick () {
      if(this.gameEnd) {
        this.currenRound = 0
        this.game.restartGame()
        this.$refs["endscore"].visible = false
        this.$refs["endscore"].opponent = ""
        this.scores.me = 0
        this.scores.opponent = 0
      }
    },
    toggleSound () {
      this.sound = !this.sound
      this.audio.toggle(this.sound)
    },
    setSound () {
      this.audio.toggle(this.sound)
    },
    findOpponent () {

    },
    // setSoundCanvas () {
    //   this.canvas = this.$refs.soundCanvas
    //   this.ctx = this.canvas.getContext("2d")
    //   this.canvas.width = this.$refs.soundCanvas.getBoundingClientRect().height * window.devicePixelRatio
    //   this.canvas.height =this.$refs.soundCanvas.getBoundingClientRect().height * window.devicePixelRatio
    //   // this.dpr = window.devicePixelRatio
    //   this.canvaswidth = this.$refs.soundCanvas.getBoundingClientRect().width * window.devicePixelRatio
    //   this.canvasheight = this.$refs.soundCanvas.getBoundingClientRect().height * window.devicePixelRatio
    //   this.canvas.style.width = this.$refs.soundCanvas.getBoundingClientRect().width + "px"
    //   this.canvas.style.height = this.$refs.soundCanvas.getBoundingClientRect().height + "px"

    //   RAF.suscribe("spundCircle", this.soundCircleUpdate.bind(this))
    //   this.soundCircleUpdate()
    // },


    // soundCircleUpdate() {
    //   const ctx = this.ctx
    //   const w = this.canvaswidth
    //   const h = this.canvasheight
    //   ctx.clearRect(0, 0, w, h)

    //   ctx.globalAlpha = 1
    //   ctx.save();
    //   ctx.beginPath();
    //   ctx.moveTo(w / 2, h / 2);
    //   ctx.lineTo(w / 2, h / 2 - h * 0.6);
    //   ctx.arc(w / 2, h / 2, w * .6, 0 - Math.PI / 2 , 2 * easing.easeInOutQuart(this.soundProgress) * Math.PI - Math.PI / 2);
    //   ctx.strokeStyle = "white"
    //   // ctx.lineWidth = 3 * this.dpr
    //   ctx.lineCap = "round"
    //   ctx.clip();
    //   ctx.drawImage(this.$refs.soundCircle, 0, 0, w, h);
    //   ctx.restore();
    //   // get hand position

    // },

    // drawCircle(){
    //   if(this.undraw) TweenMax.killTweensOf(this.undraw)
    //   this.draw = TweenMax.to(this, 1.5, {soundProgress: 0, ease: Power1.easeOut})
    // },
    // unDrawCircle(){
    //   if(this.draw) TweenMax.killTweensOf(this.draw)
    //   this.undraw = TweenMax.to(this, 1.5, {soundProgress: 1, ease: Power1.easeOut})
    // },



    toggleButtonMode () {
      this.askButton = false
      TweenMax.delayedCall(0, () => {
        this.buttonMode = !this.buttonMode
        this.game.buttonMode = this.buttonMode
        this.game.setMode(this.buttonMode)
      })
    },

    // setButtonCanvas() {
    //   this.$el.querySelectorAll('.home-button-mode-item').forEach(el => {
    //     el.canvas = el.querySelector('canvas')
    //     el.progress = 0
    //     el.ctx = el.canvas.getContext("2d")
    //     el.canvas.width = el.getBoundingClientRect().height * window.devicePixelRatio
    //     el.canvas.height =el.getBoundingClientRect().height * window.devicePixelRatio
    //     // this.dpr = window.devicePixelRatio
    //     el.canvaswidth = el.getBoundingClientRect().width * window.devicePixelRatio
    //     el.canvasheight = el.getBoundingClientRect().height * window.devicePixelRatio
    //     el.canvas.style.width = el.getBoundingClientRect().width + "px"
    //     el.canvas.style.height = el.getBoundingClientRect().height + "px"
    //     this.buttonCircleUpdate(el)
    //   })
    // },

    // buttonCircleUpdate(el) {
    //   const ctx = el.ctx
    //   const w = el.canvaswidth
    //   const h = el.canvasheight
    //   ctx.clearRect(0, 0, w, h)

    //   ctx.globalAlpha = 1
    //   ctx.save();
    //   ctx.beginPath();
    //   ctx.moveTo(w / 2, h / 2);
    //   ctx.lineTo(w / 2, h / 2 - h * 0.6);
    //   ctx.arc(w / 2, h / 2, w * .6, 0 - Math.PI / 2 , 2 * easing.easeInOutQuart(el.progress) * Math.PI - Math.PI / 2);
    //   ctx.strokeStyle = "white"
    //   // ctx.lineWidth = 3 * this.dpr
    //   ctx.lineCap = "round"
    //   ctx.clip();
    //   ctx.drawImage(this.$refs.soundCircle, 0, 0, w, h);
    //   ctx.restore();
    //   // get hand position
    // },

    // drawButtonCircle (val) {
    //   let el = document.querySelector(`.home-button-mode-item.${val}`)
    //   TweenMax.to(el, 1.5, {progress: 1, ease: Power1.easeOut, onUpdate:() => {this.buttonCircleUpdate(el)}})
    // },
    // unDrawButtonCircle(val) {
    //   let el = document.querySelector(`.home-button-mode-item.${val}`)
    //   if(!el.classList.contains('active')){
    //     TweenMax.to(el, 1.5, {progress: 0, ease: Power1.easeOut, onUpdate:() => {this.buttonCircleUpdate(el)}})
    //   }
    // },

    setMove(move){
      this.currentSign = move
      if(WebsocketManager.socket) WebsocketManager.sendTrackingData(move)
      if(!this.game.tutoEnded){
        if (this.tutoStep == 1) {
          if(move === 'rock'){
            this.glxp.setHandTarget('rock')
            this.audio.play('roundWin')
            this.glxp.animationManager.tutoSuccess()
            this.promptMessage("Great!")
            TweenMax.delayedCall(1, () => {this.setMove('none')})
            TweenMax.delayedCall(1, () => {
              this.game.nextStepTuto()
          })
          }
        }
        if (this.tutoStep == 2) {
          if(move === 'paper'){
            this.glxp.setHandTarget('paper')
            this.promptMessage("Well done!")
            this.audio.play('roundWin')
            this.glxp.animationManager.tutoSuccess()
            TweenMax.delayedCall(1, () => {this.setMove('none')})
            TweenMax.delayedCall(1, () => {
              this.game.nextStepTuto()
          })
          }
        }
        if (this.tutoStep == 3) {
          if(move === 'scissors'){
            this.audio.play('roundWin')
            this.promptMessage("You've got it!")
            this.glxp.setHandTarget('scissors')
            this.glxp.animationManager.tutoSuccess()
            TweenMax.delayedCall(1, () => {this.setMove('none')})
            TweenMax.delayedCall(1, () => {
              this.game.nextStepTuto()
          })
          }
        }
      }
     
      if (move === 'none'){
        this.$el.querySelectorAll('.home-button-mode-item').forEach(el => {
          el.classList.remove('hidden')
          el.classList.remove('active')
        })
      } else {
        this.$el.querySelectorAll('.home-button-mode-item').forEach(el => {
          if(el.classList.contains(move)){
            el.classList.remove('hidden')
            el.classList.add('active')
          } else {
            el.classList.add('hidden')
            el.classList.remove('active')
            // if (el.ctx) TweenMax.to(el, 1.5, {progress: 0, ease: Power1.easeOut, onUpdate:() => {this.buttonCircleUpdate(el)}})
          }
        })
      }
      
    }
  }
}
